<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="800px"
    custom-class="dialog-video"
  >
    <i class="el-icon-close" @click="handleClose" />
    <div class="video-wrapper">
      <iframe
        class="video-iframe"
        v-lazy-load :data-src="`${videoUrl}?autoplay=1`"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
  </el-dialog>
</template>

<script>

export default {
  props: {
    videoUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    handleOpen() {
      this.visible = true;
    },
    handleClose() {
      this.visible = false
    },
  },
}
</script>

<style lang="scss">
.dialog-video {
  border-radius: 10px;
  box-shadow: none;

  .el-icon-close {
    display: flex;
    position: absolute;
    right: -35px;
    top: -25px;
    width: 34px;
    height: 34px;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 24px;
    opacity: 0.6;
    cursor: pointer;

    &:hover {
      opacity: 1;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 50%;
    }
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .video-wrapper {
    position: relative;
    width: 800px;
    overflow: hidden;
    border-radius: 10px;

    .video-iframe {
      display: block;
      width: 100%;
      height: 450px;
    }
  }
}
</style>
